'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M640 32v352h352z' }),
        React.createElement('path', { d: 'M32 384h352v-352z' }),
        React.createElement('path', { d: 'M640 640v352l352-352z' }),
        React.createElement('path', { d: 'M384 640h-352l352 352z' })
    ));
};